// Vendor libraries
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Modules
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { PopoverModule } from 'NewAngular/features/directives/popovers/popover/popover.module';
import * as i0 from "@angular/core";
export class NewsAIChatModule {
}
NewsAIChatModule.ɵfac = function NewsAIChatModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NewsAIChatModule)(); };
NewsAIChatModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: NewsAIChatModule });
NewsAIChatModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, IconModule, FormsModule, LoadingSymbolModule, PopoverModule] });
